<template lang="pug">
  .generic-pagination.flex-row
    .flex-1
      .flex-row
        .prev
          a.btn.btn-sm.btn-default(@click="prev" :title="label.prev" :disabled="offset === 0 || loading")
            i.fa.fa-chevron-left
        div(style="width: 2px")
        .next
          a.btn.btn-sm.btn-default(@click="next" :title="label.next" :disabled="!hasMore || loading")
            i.fa.fa-chevron-right

        .flex-1
          .text-right.pr10.pt5
            span Displaying {{offset}} to {{offset+max}} records
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
      default: 15
    },
    fetch: {
      type: Function,
      required: true
    },
    urlPageParam: {
      type: String
    }
  },
  data() {
    const offset = this.urlPageParam && this.$route.query[this.urlPageParam]
    return {
      loading: false,
      offset: Number(offset || 0),
      hasMore: false,
      label: {
        prev: 'Previous page',
        next: 'Next page'
      }
    }
  },
  created() {
    this.reload()
  },
  methods: {
    reload() {
      this.loading = true
      this.fetch({ offset: this.offset, max: this.max })
        .then((hasMore) => {
          const query = {
            offset: this.offset
          }
          this.$router.push({ query })
          this.hasMore = hasMore
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.loading = false
        })
    },
    prev() {
      this.offset = this.offset - this.max
      this.reload()
    },
    next() {
      this.offset = this.offset + this.max
      this.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/IndefinitePagination.vue